import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '24px',
      position: 'absolute',
      left: 0,
      bottom: 0,
      backgroundColor: '#F7F7F7',
      color: '#747474',
      fontWeight: 400,
      fontSize: '10px',
    },
    heightOverlay: {
      width: '100%',
      height: '10px',
    }
  }
))
